import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Loader, Modal } from "@monolith-forensics/monolith-ui";

import { TimelineEventFormDefaultData } from "../Forms";
import { usePermissions } from "@/hooks/usePermissions";
import { AnalysisAPI } from "@/api";
import LoggingAPI from "@/api/logging";
import { DefaultTimelineEventForm } from "../Forms";

export const CreateTimelineEventModal: React.FC<{
  show: boolean;
  onClose?: () => void;
  onSubmit?: (data: TimelineEventFormDefaultData) => void;
  onCancel?: () => void;
  defaultFormData: TimelineEventFormDefaultData;
}> = ({ show, onClose, onSubmit, onCancel, defaultFormData }) => {
  const { currentUser } = usePermissions();
  const [submitting, setSubmitting] = useState(false);

  const createTimelineEvent = useMutation({
    mutationFn: AnalysisAPI.TimelineEvents.create,
    onMutate: () => setSubmitting(true),
    onSuccess: (_, variables: TimelineEventFormDefaultData) => {
      LoggingAPI.createLog({
        case_id: variables.case_id,
        user_id: currentUser.user_id,
        message: `Created timeline event.`,
        event: "create_timeline_event",
        object_type: "timeline_event",
        object_uuid: variables.uuid,
      });
      onSubmit?.(variables);
      setSubmitting(false);
      onClose?.();
    },
  });

  const handleSubmit = async (data: TimelineEventFormDefaultData) => {
    createTimelineEvent.mutate(data);
  };

  return (
    <Modal open={show} onClose={onClose} style={{ width: 650 }}>
      <Modal.Title>Create Timeline Event</Modal.Title>
      <Modal.SubTitle style={{ marginBottom: 15 }}>
        Create a new timeline event
      </Modal.SubTitle>
      {!submitting && (
        <DefaultTimelineEventForm
          onSubmit={handleSubmit}
          onCancel={onCancel}
          defaultFormData={defaultFormData}
        />
      )}
      {submitting && <Loader />}
    </Modal>
  );
};
